import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, SimpleGrid, Text, rem } from '@mantine/core';
import { SocialLinkItem } from './SocialLinkItem';
const socialLinks = [{
  iconClassName: 'icon-pr-flat-google',
  title: 'Google',
  active: true,
  link: '#'
}, {
  iconClassName: 'icon-pr-flat-telegram',
  title: 'Telegram',
  active: false,
  link: '#'
}, {
  iconClassName: 'icon-pr-flat-steam',
  title: 'Steam',
  active: false,
  link: '#'
}, {
  iconClassName: 'icon-pr-flat-twitch',
  title: 'Twitch',
  active: false,
  link: '#'
}];
export const SecurityLinkedCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)" mt={20} p={{
    base: 10,
    sm: 20
  }}>
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={{
      base: 10,
      sm: 12
    }} className={gunterzBold.className}>
        {i18n._('Linked accounts')}
      </Text>

      <SimpleGrid spacing={10} cols={{
      base: 1,
      sm: 2,
      lg: 1
    }} mt={24} pb={38}>
        {socialLinks.map(item => <SocialLinkItem key={item.title} {...item} />)}
      </SimpleGrid>
    </Card>;
};